import type { IconName } from '../../shared/Icon';

export type ViewName = 'today' | 'vocabulary' | 'verbPhrases' | 'progress';

export type NavigationItem = { view: ViewName; label: string; icon: IconName };

export const navigation: NavigationItem[] = [
  { view: 'today', label: 'I dag', icon: 'home' },
  { view: 'vocabulary', label: 'Ord', icon: 'book' },
  { view: 'progress', label: 'Fremgang', icon: 'chart' }
];

const verbPhraseNavigation: NavigationItem = { view: 'verbPhrases', label: 'Verbfraser', icon: 'practice' };

export function navigationFor(features: string[]): NavigationItem[] {
  return features.includes('verb-phrases')
    ? [navigation[0], navigation[1], verbPhraseNavigation, navigation[2]]
    : navigation;
}
